// This is a clone from this dead library:
// https://github.com/dzonatan/ngx-linky

/*
Angular pipe to find links in text input and turn them into html links.
It was called the same "linky" in ngSanitize module of AngularJs (first). Since Angular does not have such pipe built in
This is just a wrapper for Autolinker.js so all issues and feature requests related to autolinker should go to their issues!
*/

import { Pipe, PipeTransform } from '@angular/core';
import Autolinker, { AutolinkerConfig } from 'autolinker';
import { Replacer } from '../types';

@Pipe({ name: 'linky', standalone: true })
export class LinkyPipe implements PipeTransform {
  transform(value: string, options?: AutolinkerConfig): string {
    const linked = Autolinker.link(value, options);
    const cleaned = cleanLinks(linked);
    return cleaned;
  }
}

// see link examples in the adjacent spec file

/**
 * $1 attributes before href 1
 * $2 href 1
 * $3 attributes after href 1
 * $4 text 1
 * $5 attributes before href 2
 * $6 href 2
 * $7 attributes after href 2
 * $8 text 2
 */
const doubleLink: Replacer = {
  regex: /\[<a ([^>]*)href="([^"]+)"([^>]*)>([^<]+)<\/a>\]\(<a ([^>]*)href="([^"]+)"([^>]*)>([^<]+)<\/a>\)/g,
  replace: '<a href="$6"$5$7>$4</a>',
};

/**
 * $1 attributes before href
 * $2 mangled href
 * $3 attributes after href
 * $4 shortened URL to be used as link text
 * $5 desired href
 */
const mangledLink: Replacer = {
  regex: /\[<a ([^>]*)href="([^"]+)"([^>]*)>([^\]]+)\]\(([^<]+)\)<\/a>/g,
  replace: '<a href="$5"$1$3>$4</a>',
};
/**
 * ^ example of this type of mangled link
 * input:
 * [https://www.google.com/path/to/page](https://google.com/path/to/page)
 * linky output:
 * [<a href="https://www.google.com/path/to/page](https://google.com/path/to/page)" target="_blank" rel="noopener noreferrer">google.com/path/to/page](https://google.com/path/to/page)</a>
 * desired output:
 * <a href="https://google.com/path/to/page" target="_blank" rel="noopener noreferrer">google.com/path/to/page</a>
 */

/**
 * $1 linked text
 * $2 attributes before href
 * $3 href
 * $4 attributes after href
 * $5 text after href
 */
const singleLink: Replacer = {
  regex: /\[([^\]]+)\]\(<a ([^>]*)href="([^"]+)"([^>]*)>([^<]+)<\/a>\)/g,
  replace: '<a href="$3"$2$4>$1</a>',
};

function cleanLinks(linked: string): string {
  // loop through all replacers and apply them to the input string
  return [doubleLink, mangledLink, singleLink].reduce(
    (acc, replacer) => acc.replace(replacer.regex, replacer.replace),
    linked,
  );
}
